import type { IWorkbookInspectionNamedRange } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";

export const REF_ERROR_TOKEN = "#REF!";

export function containsRefErrorToken(refersTo: string | null | undefined): boolean {
    return (refersTo ?? "").toUpperCase().includes(REF_ERROR_TOKEN);
}

export function isBrokenNamedRangeReference(
    range: Pick<IWorkbookInspectionNamedRange, "refersTo" | "isBroken">
): boolean {
    return range.isBroken || containsRefErrorToken(range.refersTo);
}
